// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Proxima Nova:300,300i,400,400i,500,500i,700,700i);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Titillium+Web:ital,wght@0,200;0,300;0,400;0,600;0,700;0,900;1,200;1,300;1,400;1,600;1,700&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://use.typekit.net/ija5zmr.css);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.titilliumweb_font {
  font-family: "Titillium Web", sans-serif !important;
}

.text-gray4 {
  color: #707070 !important;
}

.text-gray3 {
  color: #E5E5E5 !important;
}

.border-theme {
  border-color: #ced4da !important;
}

.text-theme {
  color: #36A1F5 !important;
}

.text-blue {
  color: #231c86 !important;
}

.theme-info {
  color: #00C2FF !important;
}

.bg-theme {
  background: #36A1F5 !important;
}

.bg-darkblue {
  background: #212B65 !important;
}

.theme-red {
  color: #ff0000 !important;
}

.theme-purple {
  color: #A300FF !important;
}

.theme-darkblue {
  color: #212B64 !important;
}

.border-darkblue {
  border-color: #212B65 !important;
}

/*----------------------------------------------
    Buttons
-----------------------------------------------*/
.btn-white {
  font-weight: 400;
  color: #000000;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background-color: #ffffff;
  border: 1px solid #ffffff;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-white:hover, .btn-white:active, .btn-white:focus, .btn-white:not(:disabled):not(.disabled):active:focus, .btn-white:not(:disabled):not(.disabled).active:focus, .btn-white:not(:disabled):not(.disabled):active {
  color: #000000;
  background: #f1f3f5;
  border: 1px solid #f1f3f5;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

.btn-white-outline {
  font-weight: 400;
  color: #707070;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background-color: transparent;
  border: 1px solid #ced4da;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-white-outline:hover, .btn-white-outline:active, .btn-white-outline:focus, .btn-white-outline:not(:disabled):not(.disabled):active:focus, .btn-white-outline:not(:disabled):not(.disabled).active:focus, .btn-white-outline:not(:disabled):not(.disabled):active {
  color: #707070;
  background: #f1f3f5;
  border: 1px solid #ced4da;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

.btn-black {
  font-weight: 400;
  color: #ffffff;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background-color: #000000;
  border: 1px solid #000000;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-black:hover, .btn-black:active, .btn-black:focus, .btn-black:not(:disabled):not(.disabled):active:focus, .btn-black:not(:disabled):not(.disabled).active:focus, .btn-black:not(:disabled):not(.disabled):active {
  color: #ffffff;
  background: #212529;
  border: 1px solid #212529;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

.btn-green {
  font-weight: 400;
  color: #ffffff;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background-color: #00C596;
  border: 1px solid #00C596;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-green:hover, .btn-green:active, .btn-green:focus, .btn-green:not(:disabled):not(.disabled):active:focus, .btn-green:not(:disabled):not(.disabled).active:focus, .btn-green:not(:disabled):not(.disabled):active {
  color: #ffffff;
  background-color: #00a780;
  border: 1px solid #00a780;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

.btn-lightgreen {
  font-weight: 400;
  color: #00C596;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background-color: hsla(166, 100%, 39%, 0.11);
  border: 1px solid #00C596;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-lightgreen:hover, .btn-lightgreen:active, .btn-lightgreen:focus, .btn-lightgreen:not(:disabled):not(.disabled):active:focus, .btn-lightgreen:not(:disabled):not(.disabled).active:focus, .btn-lightgreen:not(:disabled):not(.disabled):active {
  color: #00C596;
  background-color: hsla(166, 100%, 39%, 0.4);
  border: 1px solid #009b77;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

.btn-darkblue {
  font-weight: 400;
  color: #ffffff;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background: #202B63;
  border: 1px solid #3A4789;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-darkblue:hover, .btn-darkblue:active, .btn-darkblue:focus, .btn-darkblue:not(:disabled):not(.disabled):active:focus, .btn-darkblue:not(:disabled):not(.disabled).active:focus, .btn-darkblue:not(:disabled):not(.disabled):active {
  color: #ffffff;
  background: #1c2658;
  border: 1px solid #303b74;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

.btn-darkblue-outline {
  font-weight: 400;
  color: #202B63;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background: #ffffff;
  border: 1px solid #3A4789;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-darkblue-outline:hover, .btn-darkblue-outline:active, .btn-darkblue-outline:focus, .btn-darkblue-outline:not(:disabled):not(.disabled):active:focus, .btn-darkblue-outline:not(:disabled):not(.disabled).active:focus, .btn-darkblue-outline:not(:disabled):not(.disabled):active {
  color: #ffffff;
  background: #202B63;
  border: 1px solid #3A4789;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

.btn-blue {
  font-weight: 400;
  color: #ffffff;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background-color: #077EE6;
  border: 1px solid #077EE6;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-blue:hover, .btn-blue:active, .btn-blue:focus, .btn-blue:not(:disabled):not(.disabled):active:focus, .btn-blue:not(:disabled):not(.disabled).active:focus, .btn-blue:not(:disabled):not(.disabled):active {
  color: #ffffff;
  background-color: #0172d4;
  border: 1px solid #0172d4;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

.btn-blue-outline {
  font-weight: 400;
  color: #077EE6;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background-color: #ffffff;
  border: 1px solid #077EE6;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-blue-outline:hover, .btn-blue-outline:active, .btn-blue-outline:focus, .btn-blue-outline:not(:disabled):not(.disabled):active:focus, .btn-blue-outline:not(:disabled):not(.disabled).active:focus, .btn-blue-outline:not(:disabled):not(.disabled):active {
  color: #ffffff;
  background-color: #077EE6;
  border: 1px solid #077EE6;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

.btn-lightblue {
  font-weight: 400;
  color: #ffffff;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background-color: #36A1F5;
  border: 1px solid #36A1F5;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-lightblue:hover, .btn-lightblue:active, .btn-lightblue:focus, .btn-lightblue:not(:disabled):not(.disabled):active:focus, .btn-lightblue:not(:disabled):not(.disabled).active:focus, .btn-lightblue:not(:disabled):not(.disabled):active {
  color: #ffffff;
  background-color: #2aa0fa;
  border: 1px solid #2aa0fa;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

.btn-lightblue-outline {
  font-weight: 400;
  color: #36A1F5;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background-color: #F2F9FF;
  border: 1px solid #36A1F5;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-lightblue-outline:hover, .btn-lightblue-outline:active, .btn-lightblue-outline:focus, .btn-lightblue-outline:not(:disabled):not(.disabled):active:focus, .btn-lightblue-outline:not(:disabled):not(.disabled).active:focus, .btn-lightblue-outline:not(:disabled):not(.disabled):active {
  color: #ffffff;
  background-color: #36A1F5;
  border: 1px solid #36A1F5;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

.btn-lightred {
  font-weight: 400;
  color: #CB3F3F;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background-color: #FFEFEF;
  border: 1px solid #FF004E;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-lightred:hover, .btn-lightred:active, .btn-lightred:focus, .btn-lightred:not(:disabled):not(.disabled):active:focus, .btn-lightred:not(:disabled):not(.disabled).active:focus, .btn-lightred:not(:disabled):not(.disabled):active {
  color: #CB3F3F;
  background-color: #fda3a3;
  border: 1px solid #FF004E;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

.btn-lightOrange {
  font-weight: 400;
  color: #feb019;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background-color: #f8efde;
  border: 1px solid #feb019;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-lightOrange:hover, .btn-lightOrange:active, .btn-lightOrange:focus, .btn-lightOrange:not(:disabled):not(.disabled):active:focus, .btn-lightOrange:not(:disabled):not(.disabled).active:focus, .btn-lightOrange:not(:disabled):not(.disabled):active {
  color: #feb019;
  background-color: #fce9c5;
  border: 1px solid #feb019;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

@media (min-width: 992px) {
  .Create_Question_Paper .aside,
  .own_question_paper .aside,
  .adaptive_question_papers .aside,
  .error_questions .aside,
  .un_answered .aside,
  .old_public_exam .aside {
    position: fixed;
    top: 70px;
    right: 0;
    width: 260px;
    z-index: 2;
  }
}
.Create_Question_Paper a,
.own_question_paper a,
.adaptive_question_papers a,
.error_questions a,
.un_answered a,
.old_public_exam a {
  text-decoration: none;
  color: #1B2430;
}
.Create_Question_Paper .single_question_card,
.own_question_paper .single_question_card,
.adaptive_question_papers .single_question_card,
.error_questions .single_question_card,
.un_answered .single_question_card,
.old_public_exam .single_question_card {
  position: relative;
}
.Create_Question_Paper .single_question_card .icon_block .icons,
.own_question_paper .single_question_card .icon_block .icons,
.adaptive_question_papers .single_question_card .icon_block .icons,
.error_questions .single_question_card .icon_block .icons,
.un_answered .single_question_card .icon_block .icons,
.old_public_exam .single_question_card .icon_block .icons {
  width: 50px;
  height: 50px;
  line-height: 55px;
  border-radius: 50%;
  text-align: center;
  color: #ffffff;
  margin-bottom: -2.4rem;
}
.Create_Question_Paper .single_question_card .icon_block .icons i,
.own_question_paper .single_question_card .icon_block .icons i,
.adaptive_question_papers .single_question_card .icon_block .icons i,
.error_questions .single_question_card .icon_block .icons i,
.un_answered .single_question_card .icon_block .icons i,
.old_public_exam .single_question_card .icon_block .icons i {
  font-size: 1.45rem;
}
.Create_Question_Paper .single_question_card .adaptive.icons,
.own_question_paper .single_question_card .adaptive.icons,
.adaptive_question_papers .single_question_card .adaptive.icons,
.error_questions .single_question_card .adaptive.icons,
.un_answered .single_question_card .adaptive.icons,
.old_public_exam .single_question_card .adaptive.icons {
  background: linear-gradient(91deg, #07e63f 0%, #09722c 100%);
}
.Create_Question_Paper .single_question_card .custom.icons,
.own_question_paper .single_question_card .custom.icons,
.adaptive_question_papers .single_question_card .custom.icons,
.error_questions .single_question_card .custom.icons,
.un_answered .single_question_card .custom.icons,
.old_public_exam .single_question_card .custom.icons {
  background: linear-gradient(91deg, #077EE6 0%, #3AC555 100%);
}
.Create_Question_Paper .single_question_card .error.icons,
.own_question_paper .single_question_card .error.icons,
.adaptive_question_papers .single_question_card .error.icons,
.error_questions .single_question_card .error.icons,
.un_answered .single_question_card .error.icons,
.old_public_exam .single_question_card .error.icons {
  background: linear-gradient(90deg, #A10000 0%, #E30303 100%);
}
.Create_Question_Paper .single_question_card .unanswered.icons,
.own_question_paper .single_question_card .unanswered.icons,
.adaptive_question_papers .single_question_card .unanswered.icons,
.error_questions .single_question_card .unanswered.icons,
.un_answered .single_question_card .unanswered.icons,
.old_public_exam .single_question_card .unanswered.icons {
  background: linear-gradient(90deg, #F4A00B 0%, #FFDD00 100%);
}
.Create_Question_Paper .single_question_card .public.icons,
.own_question_paper .single_question_card .public.icons,
.adaptive_question_papers .single_question_card .public.icons,
.error_questions .single_question_card .public.icons,
.un_answered .single_question_card .public.icons,
.old_public_exam .single_question_card .public.icons {
  background: linear-gradient(90deg, #CFF40B 0%, #138128 100%);
}
.Create_Question_Paper .single_card,
.own_question_paper .single_card,
.adaptive_question_papers .single_card,
.error_questions .single_card,
.un_answered .single_card,
.old_public_exam .single_card {
  position: relative;
}
.Create_Question_Paper .single_card:hover, .Create_Question_Paper .single_card.active,
.own_question_paper .single_card:hover,
.own_question_paper .single_card.active,
.adaptive_question_papers .single_card:hover,
.adaptive_question_papers .single_card.active,
.error_questions .single_card:hover,
.error_questions .single_card.active,
.un_answered .single_card:hover,
.un_answered .single_card.active,
.old_public_exam .single_card:hover,
.old_public_exam .single_card.active {
  cursor: pointer;
  box-shadow: 0px 1px 30px hsla(0, 0%, 0%, 0.2) !important;
}
.Create_Question_Paper .single_card .img_block img,
.own_question_paper .single_card .img_block img,
.adaptive_question_papers .single_card .img_block img,
.error_questions .single_card .img_block img,
.un_answered .single_card .img_block img,
.old_public_exam .single_card .img_block img {
  width: 50px;
  height: 50px;
  line-height: 55px;
  border-radius: 50%;
  text-align: center;
  color: #ffffff;
  border: 1px solid #EEEEEE;
  margin-bottom: -2.4rem;
}
.Create_Question_Paper .single_card .class_section_names,
.Create_Question_Paper .single_card .description,
.own_question_paper .single_card .class_section_names,
.own_question_paper .single_card .description,
.adaptive_question_papers .single_card .class_section_names,
.adaptive_question_papers .single_card .description,
.error_questions .single_card .class_section_names,
.error_questions .single_card .description,
.un_answered .single_card .class_section_names,
.un_answered .single_card .description,
.old_public_exam .single_card .class_section_names,
.old_public_exam .single_card .description {
  font-size: 13px;
}
.Create_Question_Paper .aside .single-list-card,
.own_question_paper .aside .single-list-card,
.adaptive_question_papers .aside .single-list-card,
.error_questions .aside .single-list-card,
.un_answered .aside .single-list-card,
.old_public_exam .aside .single-list-card {
  margin-bottom: 4px;
}
.Create_Question_Paper .aside .single-list-card:last-child,
.own_question_paper .aside .single-list-card:last-child,
.adaptive_question_papers .aside .single-list-card:last-child,
.error_questions .aside .single-list-card:last-child,
.un_answered .aside .single-list-card:last-child,
.old_public_exam .aside .single-list-card:last-child {
  margin-bottom: 0;
}
.Create_Question_Paper .aside .single-list-card .card-title,
.own_question_paper .aside .single-list-card .card-title,
.adaptive_question_papers .aside .single-list-card .card-title,
.error_questions .aside .single-list-card .card-title,
.un_answered .aside .single-list-card .card-title,
.old_public_exam .aside .single-list-card .card-title {
  font-size: 15px;
}
.Create_Question_Paper .aside .single-list-card .topic-list li,
.own_question_paper .aside .single-list-card .topic-list li,
.adaptive_question_papers .aside .single-list-card .topic-list li,
.error_questions .aside .single-list-card .topic-list li,
.un_answered .aside .single-list-card .topic-list li,
.old_public_exam .aside .single-list-card .topic-list li {
  padding: 6px 10px 0;
  margin-bottom: 4px;
}
.Create_Question_Paper .aside .single-list-card .topic-list li:last-child,
.own_question_paper .aside .single-list-card .topic-list li:last-child,
.adaptive_question_papers .aside .single-list-card .topic-list li:last-child,
.error_questions .aside .single-list-card .topic-list li:last-child,
.un_answered .aside .single-list-card .topic-list li:last-child,
.old_public_exam .aside .single-list-card .topic-list li:last-child {
  margin-bottom: 0;
}
.Create_Question_Paper .custom_exam_papers,
.own_question_paper .custom_exam_papers,
.adaptive_question_papers .custom_exam_papers,
.error_questions .custom_exam_papers,
.un_answered .custom_exam_papers,
.old_public_exam .custom_exam_papers {
  position: relative;
}
@media (min-width: 768px) {
  .Create_Question_Paper .custom_exam_papers .custom_exam_card .card-header,
  .own_question_paper .custom_exam_papers .custom_exam_card .card-header,
  .adaptive_question_papers .custom_exam_papers .custom_exam_card .card-header,
  .error_questions .custom_exam_papers .custom_exam_card .card-header,
  .un_answered .custom_exam_papers .custom_exam_card .card-header,
  .old_public_exam .custom_exam_papers .custom_exam_card .card-header {
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
  }
}
.Create_Question_Paper .Custom_Exam_Syllabus .card-group .card .subjects-list li:hover,
.Create_Question_Paper .Custom_Exam_Syllabus .card-group .card .subjects-list li.active,
.Create_Question_Paper .Custom_Exam_Syllabus .card-group .card .chapter-list li:hover,
.Create_Question_Paper .Custom_Exam_Syllabus .card-group .card .chapter-list li.active,
.own_question_paper .Custom_Exam_Syllabus .card-group .card .subjects-list li:hover,
.own_question_paper .Custom_Exam_Syllabus .card-group .card .subjects-list li.active,
.own_question_paper .Custom_Exam_Syllabus .card-group .card .chapter-list li:hover,
.own_question_paper .Custom_Exam_Syllabus .card-group .card .chapter-list li.active,
.adaptive_question_papers .Custom_Exam_Syllabus .card-group .card .subjects-list li:hover,
.adaptive_question_papers .Custom_Exam_Syllabus .card-group .card .subjects-list li.active,
.adaptive_question_papers .Custom_Exam_Syllabus .card-group .card .chapter-list li:hover,
.adaptive_question_papers .Custom_Exam_Syllabus .card-group .card .chapter-list li.active,
.error_questions .Custom_Exam_Syllabus .card-group .card .subjects-list li:hover,
.error_questions .Custom_Exam_Syllabus .card-group .card .subjects-list li.active,
.error_questions .Custom_Exam_Syllabus .card-group .card .chapter-list li:hover,
.error_questions .Custom_Exam_Syllabus .card-group .card .chapter-list li.active,
.un_answered .Custom_Exam_Syllabus .card-group .card .subjects-list li:hover,
.un_answered .Custom_Exam_Syllabus .card-group .card .subjects-list li.active,
.un_answered .Custom_Exam_Syllabus .card-group .card .chapter-list li:hover,
.un_answered .Custom_Exam_Syllabus .card-group .card .chapter-list li.active,
.old_public_exam .Custom_Exam_Syllabus .card-group .card .subjects-list li:hover,
.old_public_exam .Custom_Exam_Syllabus .card-group .card .subjects-list li.active,
.old_public_exam .Custom_Exam_Syllabus .card-group .card .chapter-list li:hover,
.old_public_exam .Custom_Exam_Syllabus .card-group .card .chapter-list li.active {
  cursor: pointer;
  border-radius: 2px;
  background: #EFEFEF;
  padding: 0.2rem 0.5rem;
}
.Create_Question_Paper .Custom_Exam_Syllabus .card-group .card .list-unstyled li,
.own_question_paper .Custom_Exam_Syllabus .card-group .card .list-unstyled li,
.adaptive_question_papers .Custom_Exam_Syllabus .card-group .card .list-unstyled li,
.error_questions .Custom_Exam_Syllabus .card-group .card .list-unstyled li,
.un_answered .Custom_Exam_Syllabus .card-group .card .list-unstyled li,
.old_public_exam .Custom_Exam_Syllabus .card-group .card .list-unstyled li {
  padding: 0.2rem 0.5rem;
  text-transform: uppercase;
}
@media (max-width: 991px) {
  .Create_Question_Paper .Custom_Exam_Syllabus .card-group .card + .card,
  .own_question_paper .Custom_Exam_Syllabus .card-group .card + .card,
  .adaptive_question_papers .Custom_Exam_Syllabus .card-group .card + .card,
  .error_questions .Custom_Exam_Syllabus .card-group .card + .card,
  .un_answered .Custom_Exam_Syllabus .card-group .card + .card,
  .old_public_exam .Custom_Exam_Syllabus .card-group .card + .card {
    border-left: 1px solid rgba(0, 0, 0, 0.125) !important;
  }
}
@media (max-width: 991px) {
  .Create_Question_Paper .Custom_Exam_Syllabus .card-group,
  .own_question_paper .Custom_Exam_Syllabus .card-group,
  .adaptive_question_papers .Custom_Exam_Syllabus .card-group,
  .error_questions .Custom_Exam_Syllabus .card-group,
  .un_answered .Custom_Exam_Syllabus .card-group,
  .old_public_exam .Custom_Exam_Syllabus .card-group {
    display: flex;
    flex-flow: column wrap;
  }
  .Create_Question_Paper .Custom_Exam_Syllabus .card-group .card,
  .own_question_paper .Custom_Exam_Syllabus .card-group .card,
  .adaptive_question_papers .Custom_Exam_Syllabus .card-group .card,
  .error_questions .Custom_Exam_Syllabus .card-group .card,
  .un_answered .Custom_Exam_Syllabus .card-group .card,
  .old_public_exam .Custom_Exam_Syllabus .card-group .card {
    flex-direction: inherit;
    margin-bottom: 15px;
  }
}
.Create_Question_Paper .table-borderless,
.own_question_paper .table-borderless,
.adaptive_question_papers .table-borderless,
.error_questions .table-borderless,
.un_answered .table-borderless,
.old_public_exam .table-borderless {
  margin-bottom: 0;
}
.Create_Question_Paper .table-borderless td,
.Create_Question_Paper .table-borderless th,
.own_question_paper .table-borderless td,
.own_question_paper .table-borderless th,
.adaptive_question_papers .table-borderless td,
.adaptive_question_papers .table-borderless th,
.error_questions .table-borderless td,
.error_questions .table-borderless th,
.un_answered .table-borderless td,
.un_answered .table-borderless th,
.old_public_exam .table-borderless td,
.old_public_exam .table-borderless th {
  padding: 0.3rem 0.5rem;
  border: 0;
}

@media (min-width: 768px) {
  .old_public_exam .custom_setup form .card .card-body .no-gutters > [class*=col-]:not(:last-child) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .old_public_exam .custom_setup form .card .card-body .no-gutters > [class*=col-]:not(:first-child) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  .old_public_exam .custom_setup form .card .card-body .no-gutters > [class*=col-] + [class*=col-] {
    margin-left: 0;
    border-left: 0;
  }
}
.old_public_exam .custom_setup form .card .card-body .chapter-list li:hover,
.old_public_exam .custom_setup form .card .card-body .chapter-list li.active {
  cursor: pointer;
  border-radius: 2px;
  background: #EFEFEF;
  padding: 0.2rem 0.5rem;
}
.old_public_exam .custom_setup form .card .card-body .list-unstyled li {
  padding: 0.2rem 0.5rem;
  text-transform: uppercase;
}

.Create_Question_Paper_type {
  position: relative;
}
.Create_Question_Paper_type a {
  text-decoration: none;
  color: #1B2430;
}
.Create_Question_Paper_type a .single-card {
  position: relative;
}
.Create_Question_Paper_type a .single-card:hover, .Create_Question_Paper_type a .single-card:focus {
  box-shadow: 0 0.5rem 1rem rgba(66, 45, 45, 0.15) !important;
}
.Create_Question_Paper_type a .single-card .icons {
  position: absolute;
  left: 20px;
  top: 15px;
  width: 70px;
  height: 70px;
  line-height: 80px;
  border-radius: 50%;
  text-align: center;
  color: #1B2430;
  border: 1px solid #DEDEDE;
  background: #DEDEDE;
  margin-bottom: -8rem;
}
.Create_Question_Paper_type a .single-card .icons i {
  font-size: 2rem;
}

#filter-popover.popover .popover-body {
  padding: 0;
}
#filter-popover.popover .popover-body .nav-tabs {
  background: #f8f9fa;
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}
#filter-popover.popover .popover-body .nav-tabs .nav-item {
  margin-bottom: 0;
}
#filter-popover.popover .popover-body .nav-tabs .nav-item .nav-link {
  border: none;
}
#filter-popover.popover .popover-body .nav-tabs .nav-link {
  font-weight: 500;
  border: none;
  color: #495057;
}
#filter-popover.popover .popover-body .nav-tabs .nav-link.active,
#filter-popover.popover .popover-body .nav-tabs .nav-item.show .nav-link {
  font-weight: 600;
  color: #121412;
  background-color: #f8f9fa;
  border-bottom: 2px solid #3ac555;
}
#filter-popover.popover .popover-body .tab-content {
  padding: 0.5rem 0.5rem 0;
  max-height: 130px;
  overflow-y: scroll;
}
#filter-popover.popover .popover-body .tab-content .custom-list li {
  margin-bottom: 6px;
}
#filter-popover.popover .popover-body .tab-content .custom-list li:not(:last-child) {
  margin-right: 0;
}
#filter-popover.popover .popover-body .tab-content .custom-list li .text {
  width: 250px;
  line-height: 20px;
}`, "",{"version":3,"sources":["webpack://./src/_config.scss","webpack://./src/neetjee_guru/components/questioners/create_question_paper/_createquestionpaper.scss"],"names":[],"mappings":"AAkCA;EACI,mDAAA;AC9BJ;;ADiCA;EACI,yBAAA;AC9BJ;;ADiCA;EACI,yBAAA;AC9BJ;;ADiCA;EACI,gCAAA;AC9BJ;;ADiCA;EACI,yBAAA;AC9BJ;;ADiCA;EACI,yBAAA;AC9BJ;;ADiCA;EACI,yBAAA;AC9BJ;;ADiCA;EACI,8BAAA;AC9BJ;;ADiCA;EACI,8BAAA;AC9BJ;;ADiCA;EACI,yBAAA;AC9BJ;;ADiCA;EACI,yBAAA;AC9BJ;;ADiCA;EACI,yBAAA;AC9BJ;;ADiCA;EACI,gCAAA;AC9BJ;;ADkCA;;gDAAA;AAIA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,yBAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;AChCJ;ADkCI;EAMI,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,iDAAA;ACrCR;;ADyCA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,6BAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;ACtCJ;ADwCI;EAMI,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,iDAAA;AC3CR;;AD+CA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,yBAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;AC5CJ;AD8CI;EAMI,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,iDAAA;ACjDR;;ADqDA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,yBAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;AClDJ;ADoDI;EAMI,cAAA;EACA,yBAAA;EACA,yBAAA;EACA,iDAAA;ACvDR;;AD2DA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,4CAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;ACxDJ;AD0DI;EAMI,cAAA;EACA,2CAAA;EACA,yBAAA;EACA,iDAAA;AC7DR;;ADiEA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,mBAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;AC9DJ;ADgEI;EAMI,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,iDAAA;ACnER;;ADuEA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,mBAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;ACpEJ;ADsEI;EAMI,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,iDAAA;ACzER;;AD6EA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,yBAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;AC1EJ;AD4EI;EAMI,cAAA;EACA,yBAAA;EACA,yBAAA;EACA,iDAAA;AC/ER;;ADoFA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,yBAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;ACjFJ;ADmFI;EAMI,cAAA;EACA,yBAAA;EACA,yBAAA;EACA,iDAAA;ACtFR;;AD0FA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,yBAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;ACvFJ;ADyFI;EAMI,cAAA;EACA,yBAAA;EACA,yBAAA;EACA,iDAAA;AC5FR;;AD+FA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,yBAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;AC5FJ;AD8FI;EAMI,cAAA;EACA,yBAAA;EACA,yBAAA;EACA,iDAAA;ACjGR;;ADqGA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,yBAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;AClGJ;ADqGI;EAMI,cAAA;EACA,yBAAA;EACA,yBAAA;EACA,iDAAA;ACxGR;;AD4GA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,yBAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;ACzGJ;AD2GI;EAMI,cAAA;EACA,yBAAA;EACA,yBAAA;EACA,iDAAA;AC9GR;;AAvWQ;EADJ;;;;;;IAEQ,eAAA;IACA,SAAA;IACA,QAAA;IACA,YAAA;IACA,UAAA;EAgXV;AACF;AA7WI;;;;;;EACI,qBAAA;EACA,cDdC;ACkYT;AAjXI;;;;;;EACI,kBAAA;AAwXR;AAtXQ;;;;;;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,sBAAA;AA6XZ;AA3XY;;;;;;EACI,kBAAA;AAkYhB;AA9XQ;;;;;;EACI,4DAAA;AAqYZ;AAlYQ;;;;;;EACI,4DAAA;AAyYZ;AAtYQ;;;;;;EACI,4DAAA;AA6YZ;AA1YQ;;;;;;EACI,4DAAA;AAiZZ;AA9YQ;;;;;;EACI,4DAAA;AAqZZ;AAjZI;;;;;;EACI,kBAAA;AAwZR;AAtZQ;;;;;;;;;;;EAEI,eAAA;EACA,wDAAA;AAiaZ;AA9ZQ;;;;;;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,yBAAA;EACA,sBAAA;AAqaZ;AAlaQ;;;;;;;;;;;;EAEI,eAAA;AA8aZ;AA1aI;;;;;;EACI,kBAAA;AAibR;AA/aQ;;;;;;EACI,gBAAA;AAsbZ;AAnbQ;;;;;;EACI,eAAA;AA0bZ;AAvbQ;;;;;;EACI,mBAAA;EACA,kBAAA;AA8bZ;AA5bY;;;;;;EACI,gBAAA;AAmchB;AA9bI;;;;;;EACI,kBAAA;AAqcR;AAncQ;EACI;;;;;;IACI,8BAAA;IACA,+BAAA;EA0cd;AACF;AAlcgB;;;;;;;;;;;;;;;;;;;;;;;;EAII,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;AAwdpB;AArdgB;;;;;;EACI,sBAAA;EACA,yBAAA;AA4dpB;AAvdQ;EACI;;;;;;IACI,sDAAA;EA8dd;AACF;AA3dQ;EACI;;;;;;IACI,aAAA;IACA,sBAAA;EAked;EAhec;;;;;;IACI,uBAAA;IACA,mBAAA;EAuelB;AACF;AAjeI;;;;;;EACI,gBAAA;AAweR;AAteQ;;;;;;;;;;;;EAEI,sBAAA;EACA,SAAA;AAkfZ;;AA5eI;EACI;IACI,0BAAA;IACA,6BAAA;EA+eV;EA5eM;IACI,yBAAA;IACA,4BAAA;EA8eV;EA3eM;IACI,cAAA;IACA,cAAA;EA6eV;AACF;AAzeI;;EAEI,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;AA2eR;AAxeI;EACI,sBAAA;EACA,yBAAA;AA0eR;;AAreA;EACI,kBAAA;AAweJ;AAteI;EACI,qBAAA;EACA,cAAA;AAweR;AAteQ;EACI,kBAAA;AAweZ;AAteY;EAEI,2DAAA;AAuehB;AApeY;EACI,kBAAA;EACA,UAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,yBAAA;EACA,mBAAA;EACA,oBAAA;AAsehB;AApegB;EACI,eAAA;AAsepB;;AA9dI;EACI,UAAA;AAieR;AA/dQ;EACI,mBAAA;EACA,+BAAA;EACA,gCAAA;AAieZ;AA9dQ;EACI,gBAAA;AAgeZ;AA9dY;EACI,YAAA;AAgehB;AA5dQ;EACI,gBAAA;EACA,YAAA;EACA,cAAA;AA8dZ;AA3dQ;;EAEI,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,gCAAA;AA6dZ;AA1dQ;EACI,wBAAA;EACA,iBAAA;EACA,kBAAA;AA4dZ;AA1dY;EACI,kBAAA;AA4dhB;AA1dgB;EACI,eAAA;AA4dpB;AAzdgB;EACI,YAAA;EACA,iBAAA;AA2dpB","sourcesContent":["// @import url('https://fonts.googleapis.com/css?family=Ubuntu:300,300i,400,400i,500,500i,700,700i&display=swap');\n@import url('https://fonts.googleapis.com/css?family=Proxima%20Nova:300,300i,400,400i,500,500i,700,700i');\n@import url('https://fonts.googleapis.com/css2?family=Titillium+Web:ital,wght@0,200;0,300;0,400;0,600;0,700;0,900;1,200;1,300;1,400;1,600;1,700&display=swap');\n@import url(\"https://use.typekit.net/ija5zmr.css\");\n\n$theme1: #36A1F5;\n$theme2: #1B2430;\n$white: #ffffff;\n$gray: #ced4da;\n$gray-2: #F2F2F2;\n$gray-3: #E5E5E5;\n$gray-4: #707070;\n$gray-5: #969DAA;\n$green: #01b306;\n$blue: #231c86;\n// #e7e9ea\n$one: #52B8FA;\n$two: #FAEF52;\n$three: #FABC52;\n$four: #AC52FA;\n$five: #FA52C2;\n$six: #FA5252;\n\n// $font-family: 'Ubuntu', sans-serif !important;\n$font-family: 'proxima-nova',\nsans-serif !important;\n\n@mixin fonts ($fontWeight, $fontSize, $lineHeight) {\n    font-family: $font-family;\n    font-size: $fontSize !important;\n    font-weight: $fontWeight !important;\n    line-height: $lineHeight;\n}\n\n.titilliumweb_font {\n    font-family: 'Titillium Web', sans-serif !important;\n}\n\n.text-gray4 {\n    color: $gray-4 !important;\n}\n\n.text-gray3 {\n    color: $gray-3 !important;\n}\n\n.border-theme {\n    border-color: $gray !important;\n}\n\n.text-theme {\n    color: $theme1 !important;\n}\n\n.text-blue {\n    color: $blue !important;\n}\n\n.theme-info {\n    color: #00C2FF !important;\n}\n\n.bg-theme {\n    background: $theme1 !important;\n}\n\n.bg-darkblue {\n    background: #212B65 !important;\n}\n\n.theme-red {\n    color: #ff0000 !important;\n}\n\n.theme-purple {\n    color: #A300FF !important;\n}\n\n.theme-darkblue {\n    color: #212B64 !important;\n}\n\n.border-darkblue {\n    border-color: #212B65 !important;\n}\n\n\n/*----------------------------------------------\n    Buttons\n-----------------------------------------------*/\n\n.btn-white {\n    font-weight: 400;\n    color: #000000;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background-color: #ffffff;\n    border: 1px solid #ffffff;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #000000;\n        background: #f1f3f5;\n        border: 1px solid #f1f3f5;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}\n\n.btn-white-outline {\n    font-weight: 400;\n    color: #707070;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background-color: transparent;\n    border: 1px solid #ced4da;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #707070;\n        background: #f1f3f5;\n        border: 1px solid #ced4da;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}\n\n.btn-black {\n    font-weight: 400;\n    color: #ffffff;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background-color: #000000;\n    border: 1px solid #000000;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #ffffff;\n        background: #212529;\n        border: 1px solid #212529;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}\n\n.btn-green {\n    font-weight: 400;\n    color: #ffffff;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background-color: #00C596;\n    border: 1px solid #00C596;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #ffffff;\n        background-color: #00a780;\n        border: 1px solid #00a780;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}\n\n.btn-lightgreen {\n    font-weight: 400;\n    color: #00C596;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background-color: hsla(166, 100%, 39%, 0.11);\n    border: 1px solid #00C596;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #00C596;\n        background-color: hsla(166, 100%, 39%, 0.4);\n        border: 1px solid #009b77;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}\n\n.btn-darkblue {\n    font-weight: 400;\n    color: #ffffff;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background: #202B63;\n    border: 1px solid #3A4789;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #ffffff;\n        background: #1c2658;\n        border: 1px solid #303b74;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}\n\n.btn-darkblue-outline {\n    font-weight: 400;\n    color: #202B63;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background: #ffffff;\n    border: 1px solid #3A4789;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #ffffff;\n        background: #202B63;\n        border: 1px solid #3A4789;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}\n\n.btn-blue {\n    font-weight: 400;\n    color: #ffffff;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background-color: #077EE6;\n    border: 1px solid #077EE6;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #ffffff;\n        background-color: #0172d4;\n        border: 1px solid #0172d4;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}\n\n\n.btn-blue-outline {\n    font-weight: 400;\n    color: #077EE6;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background-color: #ffffff;\n    border: 1px solid #077EE6;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #ffffff;\n        background-color: #077EE6;\n        border: 1px solid #077EE6;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}\n\n.btn-lightblue {\n    font-weight: 400;\n    color: #ffffff;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background-color: #36A1F5;\n    border: 1px solid #36A1F5;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #ffffff;\n        background-color: #2aa0fa;\n        border: 1px solid #2aa0fa;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}\n.btn-lightblue-outline {\n    font-weight: 400;\n    color: #36A1F5;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background-color: #F2F9FF;\n    border: 1px solid #36A1F5;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #ffffff;\n        background-color: #36A1F5;\n        border: 1px solid #36A1F5;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}\n\n.btn-lightred {\n    font-weight: 400;\n    color: #CB3F3F;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background-color: #FFEFEF;\n    border: 1px solid #FF004E;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #CB3F3F;\n        background-color: #fda3a3;\n        border: 1px solid #FF004E;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}\n\n.btn-lightOrange {\n    font-weight: 400;\n    color: #feb019;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background-color: #f8efde;\n    border: 1px solid #feb019;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #feb019;\n        background-color: #fce9c5;\n        border: 1px solid #feb019;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}","@import '../../../../config';\n\n.Create_Question_Paper,\n.own_question_paper,\n.adaptive_question_papers,\n.error_questions,\n.un_answered,\n.old_public_exam {\n    .aside {\n        @media (min-width: 992px) {\n            position: fixed;\n            top: 70px;\n            right: 0;\n            width: 260px;\n            z-index: 2;\n        }\n    }\n\n    a {\n        text-decoration: none;\n        color: $theme2;\n    }\n\n    .single_question_card {\n        position: relative;\n\n        .icon_block .icons {\n            width: 50px;\n            height: 50px;\n            line-height: 55px;\n            border-radius: 50%;\n            text-align: center;\n            color: #ffffff;\n            margin-bottom: -2.4rem;\n\n            i {\n                font-size: 1.45rem;\n            }\n        }\n\n        .adaptive.icons {\n            background: linear-gradient(91deg, #07e63f 0%, #09722c 100%);\n        }\n\n        .custom.icons {\n            background: linear-gradient(91deg, #077EE6 0%, #3AC555 100%);\n        }\n\n        .error.icons {\n            background: linear-gradient(90deg, #A10000 0%, #E30303 100%);\n        }\n\n        .unanswered.icons {\n            background: linear-gradient(90deg, #F4A00B 0%, #FFDD00 100%);\n        }\n\n        .public.icons {\n            background: linear-gradient(90deg, #CFF40B 0%, #138128 100%);\n        }\n    }\n\n    .single_card {\n        position: relative;\n\n        &:hover,\n        &.active {\n            cursor: pointer;\n            box-shadow: 0px 1px 30px hsla(0, 0%, 0%, 0.2) !important;\n        }\n\n        .img_block img {\n            width: 50px;\n            height: 50px;\n            line-height: 55px;\n            border-radius: 50%;\n            text-align: center;\n            color: #ffffff;\n            border: 1px solid #EEEEEE;\n            margin-bottom: -2.4rem;\n        }\n\n        .class_section_names,\n        .description {\n            font-size: 13px;\n        }\n    }\n\n    .aside .single-list-card {\n        margin-bottom: 4px;\n\n        &:last-child {\n            margin-bottom: 0;\n        }\n\n        .card-title {\n            font-size: 15px;\n        }\n\n        .topic-list li {\n            padding: 6px 10px 0;\n            margin-bottom: 4px;\n\n            &:last-child {\n                margin-bottom: 0;\n            }\n        }\n    }\n\n    .custom_exam_papers {\n        position: relative;\n\n        @media (min-width: 768px) {\n            .custom_exam_card .card-header {\n                border-bottom-left-radius: 4px;\n                border-bottom-right-radius: 4px;\n            }\n        }\n    }\n\n    .Custom_Exam_Syllabus {\n        .card-group {\n            .card {\n\n                .subjects-list li:hover,\n                .subjects-list li.active,\n                .chapter-list li:hover,\n                .chapter-list li.active {\n                    cursor: pointer;\n                    border-radius: 2px;\n                    background: #EFEFEF;\n                    padding: 0.2rem 0.5rem;\n                }\n\n                .list-unstyled li {\n                    padding: 0.2rem 0.5rem;\n                    text-transform: uppercase;\n                }\n            }\n        }\n\n        @media (max-width: 991px) {\n            .card-group .card+.card {\n                border-left: 1px solid rgba(0, 0, 0, 0.125) !important;\n            }\n        }\n\n        @media (max-width: 991px) {\n            .card-group {\n                display: flex;\n                flex-flow: column wrap;\n\n                .card {\n                    flex-direction: inherit;\n                    margin-bottom: 15px;\n                }\n            }\n        }\n    }\n\n\n    .table-borderless {\n        margin-bottom: 0;\n\n        td,\n        th {\n            padding: 0.3rem 0.5rem;\n            border: 0;\n        }\n    }\n}\n\n.old_public_exam .custom_setup form .card .card-body {\n    @media (min-width: 768px) {\n        .no-gutters>[class*=\"col-\"]:not(:last-child) {\n            border-top-right-radius: 0;\n            border-bottom-right-radius: 0;\n        }\n\n        .no-gutters>[class*=\"col-\"]:not(:first-child) {\n            border-top-left-radius: 0;\n            border-bottom-left-radius: 0;\n        }\n\n        .no-gutters>[class*=\"col-\"]+[class*=\"col-\"] {\n            margin-left: 0;\n            border-left: 0;\n        }\n\n    }\n\n    .chapter-list li:hover,\n    .chapter-list li.active {\n        cursor: pointer;\n        border-radius: 2px;\n        background: #EFEFEF;\n        padding: 0.2rem 0.5rem;\n    }\n\n    .list-unstyled li {\n        padding: 0.2rem 0.5rem;\n        text-transform: uppercase;\n    }\n}\n\n\n.Create_Question_Paper_type {\n    position: relative;\n\n    a {\n        text-decoration: none;\n        color: #1B2430;\n\n        .single-card {\n            position: relative;\n\n            &:hover,\n            &:focus {\n                box-shadow: 0 0.5rem 1rem rgba(66, 45, 45, 0.15) !important\n            }\n\n            .icons {\n                position: absolute;\n                left: 20px;\n                top: 15px;\n                width: 70px;\n                height: 70px;\n                line-height: 80px;\n                border-radius: 50%;\n                text-align: center;\n                color: #1B2430;\n                border: 1px solid #DEDEDE;\n                background: #DEDEDE;\n                margin-bottom: -8rem;\n\n                i {\n                    font-size: 2rem;\n                }\n            }\n        }\n    }\n}\n\n#filter-popover.popover {\n    .popover-body {\n        padding: 0;\n\n        .nav-tabs {\n            background: #f8f9fa;\n            border-top-left-radius: 0.25rem;\n            border-top-right-radius: 0.25rem;\n        }\n\n        .nav-tabs .nav-item {\n            margin-bottom: 0;\n\n            .nav-link {\n                border: none;\n            }\n        }\n\n        .nav-tabs .nav-link {\n            font-weight: 500;\n            border: none;\n            color: #495057;\n        }\n\n        .nav-tabs .nav-link.active,\n        .nav-tabs .nav-item.show .nav-link {\n            font-weight: 600;\n            color: #121412;\n            background-color: #f8f9fa;\n            border-bottom: 2px solid #3ac555;\n        }\n\n        .tab-content {\n            padding: 0.5rem 0.5rem 0;\n            max-height: 130px;\n            overflow-y: scroll;\n\n            .custom-list li {\n                margin-bottom: 6px;\n\n                &:not(:last-child) {\n                    margin-right: 0;\n                }\n\n                .text {\n                    width: 250px;\n                    line-height: 20px;\n                }\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
